<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden pe-sm-4">
        <dx-data-grid
            class="grid theme-dependent"
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [allowColumnReordering]="true"
            [autoNavigateToFocusedRow]="false"
            [focusedRowEnabled]="true"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="false"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'file-imports-grid-state', savingTimeout: 0 }"
            (onExporting)="onExporting($event)"
            [customizeColumns]="customizeColumns"
            (onRowDblClick)="onRowDblClick($event)"
            keyExpr="id"
            width="100%"
        >
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-search-panel [visible]="true" placeholder="Search"></dxo-search-panel>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">File Imports</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="never"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="never"
                    widget="dxButton"
                    showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{
                            text: 'Reset',
                            icon: 'restore',
                            onClick: resetGrid,
                            stylingMode: 'text'
                        }"
                ></dxi-item>
                <!-- Separator -->
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="gridFieldName('fileName')" [allowSorting]="true" [allowFiltering]="true" cellTemplate="fileNameTemplate" [minWidth]="250"></dxi-column>
            <dxi-column [dataField]="gridFieldName('fileType')" [allowSorting]="true" [allowFiltering]="true" [lookup]="{ dataSource: fileTypeOptions, valueExpr: 'value', displayExpr: 'text' }" [minWidth]="150"></dxi-column>
            <dxi-column [dataField]="gridFieldName('lastModified')" [allowSorting]="true" [allowFiltering]="true" dataType="datetime" sortOrder="desc" selectedFilterOperation=">=" [minWidth]="150"></dxi-column>
            <dxi-column [dataField]="gridFieldName('created')" [allowSorting]="true" [visible]="false" [allowFiltering]="true" dataType="datetime" selectedFilterOperation=">=" [minWidth]="150"></dxi-column>
            <dxi-column [dataField]="gridFieldName('createdByName')" caption="Created By" [visible]="false" [minWidth]="250" cellTemplate="createdByTemplate" [calculateFilterExpression]="nameOrEmailFilter"></dxi-column>
            <dxi-column [dataField]="gridFieldName('message')" caption="Message" [allowSorting]="true" [allowFiltering]="true" cellTemplate="error" [width]="600"></dxi-column>

            <div *dxTemplate="let cell of 'fileNameTemplate'">
                <a href="#" [appSignedLink]="getCellData(cell).url" title="Download">
                    <span [ngClass]="{ 'text-danger': cell.data.status === FileImportStatus.Failed }">{{ cell.text }}</span>
                </a>
            </div>
            <div *dxTemplate="let cell of 'error'">
                @if (getCellData(cell).status === FileImportStatus.Failed) {
                    <i class="fas fa-exclamation-triangle text-danger"></i>
                    <span class="ms-1" [innerHTML]="getCellData(cell).message"></span>
                } @else if (getCellData(cell).status === FileImportStatus.Processing) {
                    <i class="far fa-clock text-secondary"></i>
                } @else {
                    <i class="far fa-check-circle text-success"></i>
                    @if (getCellData(cell).message) {
                        <span class="ms-1" [innerHTML]="getCellData(cell).message"></span>
                    }
                }
            </div>
            <div *dxTemplate="let cell of 'createdByTemplate'">
                <user-avatar-email
                    [email]="getCellData(cell).createdByEmail"
                    [name]="getCellData(cell).createdByName"
                    [avatarUrl]="getCellData(cell).createdByAvatar"
                ></user-avatar-email>
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item [dataField]="filterModelName('fileName')" [editorOptions]="{ placeholder: 'File Name', stylingMode: 'filled' }"></dxi-item>
            <dxi-item
                [dataField]="filterModelName('fileType')"
                editorType="dxSelectBox"
                [editorOptions]="{
                    placeholder: 'File Type',
                    stylingMode: 'filled',
                    items: fileTypeOptions,
                    valueExpr: 'value',
                    displayExpr: 'text'
                }"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('status')"
                editorType="dxSelectBox"
                [editorOptions]="{
                    placeholder: 'Status',
                    stylingMode: 'filled',
                    items: statusOptions,
                    valueExpr: 'value',
                    displayExpr: 'text'
                }"
            ></dxi-item>
            <dxi-item [dataField]="filterModelName('lastModified')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Updated', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('created')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Created', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('createdByName')" [editorOptions]="{ placeholder: 'Created By', stylingMode: 'filled' }"></dxi-item>
            <dxi-item [dataField]="filterModelName('message')" [editorOptions]="{ placeholder: 'Message', stylingMode: 'filled' }"></dxi-item>
        </dx-form>
    </filter-panel>

    <app-popup-message
        [(visible)]="isPopupOpened"
        [title]="messagePopupTitle"
        [message]="messagePopupMessage"
        [isError]="isErrorPopup"
    ></app-popup-message>
</div>
